import React from 'react'
import { withOnlyPE } from '../Device'
import s from './Anchor.less'

const Anchor = () => <div className={s.anchor} />

export default withOnlyPE(Anchor)
